import { stopBackgroundActivity, closeSidePanel } from '@/modules/helper'
import uaqPlugin from '@/modules/uaq/uaqPlugin'
import createDesignSettingUpdater from '@/plugins/DesignSettingsUpdater'
import createEmulatorPlugin from '@/plugins/Emulator'
import queryString from 'query-string'

import Vue from 'vue'

import Vuex from 'vuex'

import appConfig from './modules/appconfig'

import * as actions from './actions'

import team from './modules/team'
import facebook from './modules/Facebook'
import website from './modules/website'
import pdf from './modules/Pdf'
import ContentPage from './modules/contentPages'

import ImageGalleries from './modules/imageGalleries'

import Streams from './modules/radioStream'

import rssfeed from './modules/rssfeed'

import Form from './modules/form'
import Resource from './modules/resource'

import Youtube from './modules/youtube' 
import Chat from './modules/chat'
import instagram from './modules/instagram'
import twitter from './modules/twitter'
import customCode from './modules/customCode'

Vue.use(Vuex)

Vue.use({
  install(Vue, parameters) {
    Vue.prototype.$setSidePanelActive = function(value) {
      this.$store.dispatch('setSidePanelActive', value)
    }
  }
})

let plugins = [
  uaqPlugin,
  createDesignSettingUpdater()
]
const params = queryString.parse(location.search)
if (params.devsim === 'true') {
  plugins.push(createEmulatorPlugin())
}

const store = new Vuex.Store({
  actions,
  plugins,
  modules: {
    appConfig,
    team,
    rssfeed,
    facebook,
    website,
    ContentPage,
    ImageGalleries,
    Streams,
    Form,
    Resource,
    Youtube,
    Chat,
    instagram,
    twitter,
    customCode,
    pdf
  }
})
export const routeEvent = {
  pageBeforeIn (event, page) {
    // console.log('routeEvent',event,page)
    stopBackgroundActivity(store)
    closeSidePanel(store)
  }
}
export default store



// WEBPACK FOOTER //
// ./src/store/store.js